module.exports = __webpack_public_path__ + "img/client5.34e94383.png";